module.exports = __webpack_public_path__ + "img/survey.add548d7.svg";